'use client';

import { PropsWithChildren, createContext, useContext, useState } from 'react';

interface TokenContextType {
  token?: string;
  updateTokenState: (token: string) => void;
}

const TokenContext = createContext<TokenContextType | undefined>(undefined);

export function TokenProvider({ children }: PropsWithChildren) {
  const [token, setToken] = useState<string>();

  function updateTokenState(newToken: string) {
    setToken(newToken);
  }

  return (
    <TokenContext.Provider value={{ token, updateTokenState }}>{children}</TokenContext.Provider>
  );
}

export function useToken() {
  const context = useContext(TokenContext);
  if (context === undefined) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  return context;
}
